import { filter, map, type Observable, tap } from 'rxjs';
import { openOKDialog } from '@pct-ng/feature-message-material';
import { messageDialogOptionsGenerator } from '../../message-dialog-options-generator';
import type { NotFoundServerError } from './not-found-server.error';

export function handleNotFoundServerError(
  i18nScope: string,
  i18nReloadKey: string,
  error: NotFoundServerError,
): Observable<NotFoundServerError> {
  return openOKDialog(
    messageDialogOptionsGenerator(`${i18nScope}.NOT_FOUND_SERVER`),
    i18nReloadKey,
  ).pipe(
    map(() => error),
    tap(() => window.location.reload()),
    filter(() => false),
  );
}
